module.exports = __webpack_public_path__ + "img/outlook-calendar.e7c13074.png";